<template>
  <div class="xcard" style="width:700px" id="recibito">
    <div class="row">
      <div class="col-sm-2">
        <img class="img-responsive" :src="img_logo" alt="">
      </div>
      <div class="col-sm-10 text-center">
        <h4>ESCUELA DE ADMINISTRACION</h4>
        <h4>MARKETING Y NEGOCIOS</h4>
      </div>
    </div>

    <h4 class="text-center text-primary"> <b>RECIBO</b></h4>
    <div class="row">
      <div class="col-sm-3">
        <table class="table table-condensed table-bordered">
          <thead>
            <tr>
              <th>Lugar</th>
              <th>Dia</th>
              <th>Mes</th>
              <th>Año</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tarija</td>
              <td>16</td>
              <td>04</td>
              <td>2020</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-3 text-center"> <b>NO 32323232</b> </div>
      <div class="col-sm-2">
        <p>{{name}} - </p>
        <span>Bs. </span> <input class="form-control input-sm" style="width:60px" type="text" value="300">
      </div>
    </div>

    <p> <b>Nombres y apellidos:</b> <span class="dotted"> <i>Miguel Aangel</i> </span> <b>Ocupacion:</b> <span class="dotted"></span> </p>
    <p> <b>Direccion Dom.:</b> <span> <i>Miguel Aangel</i> </span> </p>
    <p> <b>Direccion Of.:</b> <span> <i>Miguel Aangel</i> </span> </p>
    <p> <b>Por concepto de:</b> <span> <i>Miguel Aangel</i> </span> </p>
    <p> <b>Son:</b> <span> <i>Miguel Aangel</i> </span> <b>Saldo:</b> <span class="dotted"> <i>&nbsp;</i> </span> </p>
    <p> <b>Asesor ejec.:</b> <span> <i>Miguel Aangel</i> </span> </p>
    <a title="Generar Recibo." @click="genRecibo()"> <span class="text-white glyphicon glyphicon-print">. </span> </a>
  </div>
</template>

<script>
import {generarRecibo} from '@/components/recibo.js'

export default {
  data(){
    return{
      pago:{},
      img_logo: process.env.VUE_APP_LOGO,
      name: process.env.VUE_APP_NAME
    }
  },
  methods:{
    genRecibo(){
      generarRecibo( this.pago );
    }
  },
  mounted(){
    this.pago = sessionStorage.xrecpago;

  }
}
</script>